<div class="dash-array">
    @if (!dashArray || dashArray.length === 0) {
      <div
        class="line full"
        [ngStyle]="{ background: color }"
      >
      </div>
    } @else if (!!dashArray && dashArray.length > 0) {
      <div class="line">
        @for (i of [].constructor(Math.round(36 / getDashArrayPixelLength(dashArray))); track $index) {
          @for(dash of dashArray; track $index; let dashIndex = $index) {
            <div [ngStyle]="{ 'height.px': 3,
                              'width.px': dashIndex % 2 > 0 ? dash : 3*dash,
                              'min-width.px': dashIndex % 2 > 0 ? dash : 3*dash,
                               background: dashIndex % 2 > 0 ? gapColor : color,
                               display: 'inline-block'
                             }">
            </div>
          }
        }
      </div>
    }
</div>
